import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/app_store_badge.webp")